export const GET_ASPECTRATIOS_STATED = "GET_ASPECTRATIOS_STATED";
export const GET_ASPECTRATIOS = "GET_ASPECTRATIOS";
export const GET_ASPECTRATIOS_ENDED = "GET_ASPECTRATIOS_ENDED";
export const ADD_ASPECTRATIO_STATED = "ADD_ASPECTRATIO_STARTED";
export const ADD_ASPECTRATIO = "ADD_ASPECTRATIO";
export const ADD_ASPECTRATIO_ENDED = "ADD_ASPECTRATIO_ENDED";
export const EDIT_ASPECTRATIO_STATED = "EDIT_ASPECTRATIO_STATED";
export const EDIT_ASPECTRATIO = "EDIT_ASPECTRATIO";
export const EDIT_ASPECTRATIO_ENDED = "EDIT_ASPECTRATIO_ENDED";
export const GET_ASPECTRATIO = "GET_ASPECTRATIO";
export const GET_ASPECTRATIO_STATED = "GET_ASPECTRATIO_STATED";
export const GET_ASPECTRATIO_ENDED = "GET_ASPECTRATIO_ENDED";
export const RESET_ASPECTRATIO = "RESET_ASPECTRATIO";
export const ERROR_ASPECTRATIO = "ERROR_ASPECTRATIO";
export const GET_ALL_ASPECTRATIOS_STATED = "GET_ALL_ASPECTRATIOS_STATED";
export const GET_ALL_ASPECTRATIOS = "GET_ALL_ASPECTRATIOS";
export const GET_ALL_ASPECTRATIOS_ENDED = "GET_ALL_ASPECTRATIOS_ENDED";
